// Used when reordering a columns.
// This returns the "orderBy" value of the next column (column to the right) of the columnID passed in.
export function getNextColumnOrderBy(columnID, columns) {
  try {
    const colIndex = columns.findIndex((col) => col.ID === columnID);
    const nextColOrderBy = columns[colIndex + 1]?.orderBy;

    return nextColOrderBy || columns.length;
  } catch (e) {
    return columns.length;
  }
}

// Used when reordering a columns.
// This returns the "orderBy" value of the previous column (column to the left) of the columnID passed in.
export function getPrevColumnOrderBy(columnID, columns) {
  try {
    const colIndex = columns.findIndex((col) => col.ID === columnID);
    const prevColOrderBy = columns[colIndex - 1]?.orderBy;

    return prevColOrderBy || columns.length;
  } catch (e) {
    return columns.length;
  }
}
